import React from "react"
import ProjectCard from "components/ProjectCard/ProjectCard"
import { graphql, useStaticQuery } from "gatsby"
import HomeSectionWrapper from "components/HomePage/components/HomeSectionWrapper"
import { AVAILABLE_ROUTES } from "containers/Layout/components/NavBar"
import projectsDescription from "components/shared/ProjectsDescription"

const HomeSecondSection = () => {
  //Grab the static content that gatsby fetched at build time for github
  const { github } = useStaticQuery(
    graphql`
      query TopFourGithubProjects {
        github {
          organization(login: "mercedes-benz") {
            login
            pinnedItems(first: 4, types: REPOSITORY) {
              nodes {
                ... on GitHub_Repository {
                  name
                  url
                  name
                  stargazerCount
                  forkCount
                  description
                  watchers {
                    totalCount
                  }
                  languages(
                    first: 1
                    orderBy: { field: SIZE, direction: DESC }
                  ) {
                    nodes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  const fourProjects = github?.organization?.pinnedItems?.nodes?.map(
    (project, index) => (
      <ProjectCard
        grid={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
        key={index}
        {...{ ...project }}
      />
    )
  )
  return (
    <HomeSectionWrapper
      {...{
        sectionTitle: "Projects",
        sectionDescription: "Let's collaborate and code together",
        sectionButtonTitle: "Show all projects",
        sectionButtonLink: AVAILABLE_ROUTES.PROJECTS.to,
        sectionSubDescription: projectsDescription,
      }}
    >
      {fourProjects}
    </HomeSectionWrapper>
  )
}

export default HomeSecondSection
